import { Element } from "@siteimprove/alfa-dom";
import { Maybe, None, Option } from "@siteimprove/alfa-option";
import { Universal } from "../../index.js";
import { WithIndexAndSelector } from "./pseudo-class.js";
const { isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#nth-last-child-pseudo}
 */
export class NthLastChild extends WithIndexAndSelector {
    static of(index, selector = None) {
        return new NthLastChild(index, Maybe.toOption(selector));
    }
    _indices = new WeakMap();
    constructor(nth, selector) {
        super("nth-last-child", nth, selector);
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context) {
        if (!this._indices.has(element)) {
            element
                .inclusiveSiblings()
                .filter(isElement)
                .filter((element) => this._selector
                .getOr(Universal.of(Option.of("*")))
                .matches(element, context))
                .reverse()
                .forEach((element, i) => {
                this._indices.set(element, i + 1);
            });
        }
        if (!this._indices.has(element)) {
            return false;
        }
        return this._index.matches(this._indices.get(element));
    }
    equals(value) {
        return value instanceof NthLastChild && super.equals(value);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (NthLastChild) {
    NthLastChild.parse = (parseSelector) => WithIndexAndSelector.parseWithIndexAndSelector("nth-last-child", parseSelector, NthLastChild.of);
})(NthLastChild || (NthLastChild = {}));
//# sourceMappingURL=nth-last-child.js.map